import { useFlowAnalyticsEventsQueueStore } from '@/v2/domains/Analytics/stores/flowAnalyticsEventsQueue.store';

import {
  PaymentFlowEventName,
  PaymentSection,
  PaymentFlowStep,
  PaymentFlowEventData,
} from '@/v2/domains/Analytics/types/payment';
import getFlowStepIndex from '@/v2/domains/Analytics/utils/getFlowStepIndex';
import useTrackPlausibleFlowEvent from './useTrackPlausibleFlowEvent.hook';

export default function usePaymentFlowAnalytics({
  section,
  step,
}: {
  section: PaymentSection;
  step: PaymentFlowStep;
}) {
  const { enqueueEvent, flow, setFlow, clearPendingEvents } =
    useFlowAnalyticsEventsQueueStore();

  const trackFlowEvent = useTrackPlausibleFlowEvent();

  const sendEvent = (
    event: PaymentFlowEventName,
    { calculationData, option }: PaymentFlowEventData = {}
  ) => {
    if (flow) {
      trackFlowEvent({
        event,
        flow,
        section,
        step,
        stepIndex: getFlowStepIndex(flow, step),
        option,
      });
    } else {
      enqueueEvent({
        event,
        section,
        step,
        option,
        calculationData,
      });
    }
  };

  return {
    onStepViewed: (data?: PaymentFlowEventData) =>
      sendEvent(PaymentFlowEventName.stepViewed, data),
    onOptionSelected: (data?: PaymentFlowEventData) =>
      sendEvent(PaymentFlowEventName.optionSelected, data),
    onContinue: (data?: PaymentFlowEventData) =>
      sendEvent(PaymentFlowEventName.stepContinue, data),
    onFailed: (data?: PaymentFlowEventData) =>
      sendEvent(PaymentFlowEventName.failed, data),
    onSkip: () => {
      clearPendingEvents();
      setFlow(null);
    },
  };
}
